import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

import globalStyles from './pc-office-card.lightDom.css.lit';
import componentStyles from './pc-office-card.css.lit';

/**
 * Office card component
 * @element pc-office-card
 * @slot - This element has a default slot
 */
@customElement('pc-office-card')
export class PCOfficeCard extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  adoptedStylesheets: AdoptedStyleSheets;

  @property({ type: Boolean, attribute: 'is-main' })
  isMain = false;

  connectedCallback() {
    super.connectedCallback();

    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  render(): TemplateResult {
    return html`
      <div class="office-card">
        <slot name="heading"></slot>

        <div class="content">
          <slot></slot>
        </div>

        <div class="contact">
          <slot name="address"></slot>
          <div class="phones-social">
            <slot name="phones"></slot>
            <slot name="social"></slot>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-office-card': PCOfficeCard;
  }
}
